import type { KeyboardEvent } from 'react';

/** Marks an element the menu's arrow keys move between. */
export const MENU_ITEM_ATTRIBUTE = 'data-admin-item';

/**
 * 06-qol §2: every list is arrow-key navigable. Up and Down move between the menu's items, Home and End jump to
 * the ends; Tab still leaves the menu in one press, because only one item at a time is in the tab order.
 * Returns true when it moved, so a caller can leave every other key alone.
 */
export function moveMenuFocus(event: KeyboardEvent<HTMLElement>): boolean {
  const target = event.target;
  if (!(target instanceof HTMLElement) || !target.hasAttribute(MENU_ITEM_ATTRIBUTE)) return false;
  const items = Array.from(event.currentTarget.querySelectorAll<HTMLElement>(`[${MENU_ITEM_ATTRIBUTE}]`));
  const index = items.indexOf(target);
  if (index === -1) return false;

  const last = items.length - 1;
  let next: number | null = null;
  if (event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
  else if (event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
  else if (event.key === 'Home') next = 0;
  else if (event.key === 'End') next = last;
  if (next === null) return false;

  event.preventDefault();
  items[next]?.focus();
  return true;
}
